import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Client } from "resourceModels";
import { getResource } from "selectors/resources";
import { ResponseRecord } from "reducers/responses/reducer";
import InfoTooltip from "components/Common/InfoTooltip";
import QuickReplyLabelInput from "../QuickReplyLabelInput";
import "./style.scss";

export class MultiLangAnswerLabels extends Component {
  /**
   * render
   * @returns {ReactElement}
   */
  render() {
    const {
      /** @type Client */
      client,
      sortedButtonLabels,
      response,
      languageButton,
      handleUpdateButtonLabel,
      handleDeleteButtonLabel
    } = this.props;

    const shouldShowMultipleLanguages = !(
      client.translatedLanguages.isEmpty() &&
      sortedButtonLabels.length < 2
    );

    const actions = { handleDeleteButtonLabel, handleUpdateButtonLabel };

    const getQuickReplyLabelInputList = () => {
      const list = sortedButtonLabels.map((languageTuple, i) => {
        const isPrimary = languageTuple[0] === client.language;
        const key = `QuickReplyLabelInput-${i}`;

        return (
          <QuickReplyLabelInput
            key={key}
            translations={client.features.get("translations")}
            clientLanguageCode={client.language}
            handleUpdateButtonLabel={handleUpdateButtonLabel}
            handleDeleteButtonLabel={languageCode => actions.handleDeleteButtonLabel(languageCode)}
            languageButton={languageButton}
            value={languageTuple[1]}
            isPrimary={isPrimary}
            languageCode={languageTuple[0]}
            shouldShowMultipleLanguages={shouldShowMultipleLanguages}
            responseHandle={response.handle}
            placeholder="Enter your default button text here"
          />
        );
      });

      return list;
    };

    return (
      <div className="MultiLangAnswerLabels">
        <div className="MultiLangAnswerLabels__header">
          <div className="MultiLangAnswerLabels__title">
            <h3 className="g-form__block__label MultiLangAnswerLabels__headline">Answer Label</h3>
            <div className="MultiLangAnswerLabels__tooltip">
              <InfoTooltip
                blurb="Chatters click this text to trigger an Answer during chat. It is used in Quick Replies, Clarifications and Suggestions."
                iconDefault="QuestionCircle"
                iconClicked="QuestionCircleFilled"
                maxWidth={218}
              />
            </div>
          </div>
          {shouldShowMultipleLanguages &&
              languageButton}
        </div>
        <div>
          <p className="MultiLangAnswerLabels__description">
            Add a short label to help chatters understand what this answer is about.
          </p>
        </div>
        <div className="MultiLangAnswerLabels__language-buttons">{getQuickReplyLabelInputList()}</div>
      </div>
    );
  }
}

MultiLangAnswerLabels.propTypes = {
  sortedButtonLabels: PropTypes.arrayOf(PropTypes.array.isRequired).isRequired,
  response: PropTypes.instanceOf(ResponseRecord).isRequired,
  languageButton: PropTypes.node.isRequired,
  handleUpdateButtonLabel: PropTypes.func.isRequired,
  handleDeleteButtonLabel: PropTypes.func.isRequired,

  client: PropTypes.instanceOf(Client).isRequired
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client")
  };
}

const Connector = connect(mapStateToProps)(MultiLangAnswerLabels);

Connector.propTypes = {
  sortedButtonLabels: PropTypes.arrayOf(PropTypes.array.isRequired).isRequired,
  response: PropTypes.instanceOf(ResponseRecord).isRequired,
  languageButton: PropTypes.node.isRequired,
  handleUpdateButtonLabel: PropTypes.func.isRequired,
  handleDeleteButtonLabel: PropTypes.func.isRequired
};

export default Connector;
